var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.unreadMsg
    ? _c("div", { staticClass: "info-push" }, [
        _c(
          "div",
          {
            staticClass: "inside-box",
            on: {
              click: function ($event) {
                return _vm.updateRead("a")
              },
            },
          },
          _vm._l(_vm.allUnreadMessage, function (item, i) {
            return _c("p", { key: i }, [
              _vm._v(" " + _vm._s(item.content) + " "),
            ])
          }),
          0
        ),
        _c("i", {
          staticClass: "close-icon el-icon-close",
          on: {
            click: function ($event) {
              return _vm.updateRead("b")
            },
          },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }